import axios from "axios";
import { API } from "./auth";

export const getMissingQuoteFields = (form) => {
  const missing = [];
  if (!form.nome.trim()) missing.push("Nome");
  if (!form.telefone.trim()) missing.push("Telefone");
  if (!form.email.trim()) missing.push("Email");
  if (!form.veiculo.trim()) missing.push("Veículo");
  if (!form.servico) missing.push("Serviço pretendido");
  if (form.servico !== "Troca de Pneus") return missing;
  if (!form.medida_pneu.trim()) missing.push("Medida do pneu");
  if (!form.quantidade || Number(form.quantidade) < 1) missing.push("Quantidade");
  if (form.preferencia_marca && !form.marca_preferida.trim()) missing.push("Marca preferida");
  return missing;
};

export const buildQuotePayload = (form) => ({
  ...form,
  quantidade: Number(form.quantidade) || 4,
  marca_preferida: form.preferencia_marca
    ? form.marca_preferida.trim() || "Sim (não especificada)"
    : "Não",
});

export const submitQuote = (form) =>
  axios.post(`${API}/quotes`, buildQuotePayload(form), { withCredentials: true });

export const toJpgName = (name) => {
  const safe = name.replace(/[^a-zA-Z0-9._-]/g, "_");
  return /\.jpe?g$/i.test(safe) ? safe : `${safe.replace(/\.[^.]+$/, "")}.jpg`;
};
